import { motion } from "framer-motion";
import "./Sign.css";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
AOS.init();

const Sign = () => {
  return (
    <div className="signBackground">
      <div className="sign">
        <div className="signLogo">
          <img
            src="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
            alt=""
          />
        </div>
        <h3>CHOOSE HOW TO SIGN IN TO YOUR EPIC ACCOUNT</h3>
        <motion.div
          className="signOptions"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          <div className="signOne">
            <img
              src="https://cdn2.unrealengine.com/Unreal+Engine%2Feg-logo-filled-1255x1272-0eb9d144a0f981d1cbaaa1eb957de7a3207b31bb.png"
              alt=""
            />
          </div>
          <h2>SIGN IN WITH EPIC GAMES</h2>
        </motion.div>
        <motion.div
          className="signOptions"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-delay="500"
         
        >
          <div className="signTwo">
            <i class="fab fa-facebook" />
          </div>
          <h2>SIGN IN WITH EPIC FACEBOOK</h2>
        </motion.div>
        <div
          className="signOptions"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-delay="1000"
        >
          <div className="signThree">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRoAbZUfVUgAB3F7PrFvnrseBXmYJ2goO2-jGeIBH5sqD8nD_ZyCC8MAI1jzQo3ZnnCQrE&usqp=CAU"
              alt=""
            />
          </div>
          <h2>SIGN IN WITH EPIC GOOGLE</h2>
        </div>
        <div
          className="signOptions"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-delay="1500"
        >
          <div className="signTwo Four">
            <i class="fab fa-xbox" />
          </div>
          <h2>SIGN IN WITH EPIC XBOX LIVE</h2>
        </div>
        <div
          className="signOptions"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-delay="2000"
        >
          <div className="signTwo Five">
            <i class="fab fa-playstation" />
          </div>
          <h2>Sign in with PlayStation™</h2>
        </div>
        <div
          className="signOptions"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-delay="2500"
        >
          <div className="signTwo Six">
            <i class="fab fa-steam" />
          </div>
          <h2>Sign in with steam</h2>
        </div>
        <div
          className="signOptions"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-delay="3500"
        >
          <div className="signTwo Eight">
            <i class="fab fa-android" />
          </div>
          <h2>Sign in with android</h2>
        </div>
        <div
          className="signOptions"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          data-aos-delay="1000"
        >
          <div className="signSeven ">
            <i class="fab fa-apple" />
          </div>
          <h2>Sign in with Apple</h2>
        </div>
        <div className="SignUp">
          <h3>
            Don't have an Epic Games account? <span>Sign Up</span>{" "}
          </h3>
        </div>
      </div>
    </div>
  );
};

export default Sign;
